declare var swal: any;
import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SpinnerService } from '../../../../services/spinner.service';
import { AppData } from '../../../../models/appdata';
import { ApiResponseModel } from '../../../../models/api_response_model';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { NgbCertificationsinfoModal } from './modals/certificationinfo.modal'
import { ActorCertificationRequest, ActorCertificationsInfoController } from '../../../../models/actor/actor';
import { ActorService } from '../../../../services/actor.service';
import { DBOperation } from '../../../../enums/enum';
import { ActorIdentitiesPipe } from '../../../../pipes/actors/actorIdentity.pipes';
import * as alertFunctions from '../../../../../shared/data/sweet-alerts';
import { NgbActorDocsModal } from '../modals/actordocs/actordocs.modal';
import { HCPService } from '../../../../services/hcp.service';



@Component({
  selector: 'certificationsinfo',
  templateUrl: './certificationsinfo.component.html',
  styleUrls: ['./certificationsinfo.component.scss']
})

export class CertificationsInfoComponent implements OnInit {
  @Input() ActorCode: number;
  @Input() ActorType: number;

  @Input() CanEdit: number;
  @Input() CanShow: number;
  @Input() CanShowRegistryView: number;

  CurrentActorCertificationRequest: ActorCertificationRequest;
  CurrentActorCertificationsInfoController: ActorCertificationsInfoController[];
  public ApiResData: ApiResponseModel;
  public isRequesting: boolean = false;


  constructor(private router: Router,
    private route: ActivatedRoute, private loaderService: SpinnerService, private hcpservice: HCPService, private actoridentitiespipe: ActorIdentitiesPipe,
    private modalService: NgbModal) { }


  ngOnInit() {

    this.CurrentActorCertificationRequest = new ActorCertificationRequest();
    this.CurrentActorCertificationsInfoController = new Array<ActorCertificationsInfoController>();
    this.CurrentActorCertificationRequest.ActorCode = this.ActorCode;
    //AppData.Instance().UserLoginDetails.ActorCode;
    this.CurrentActorCertificationRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    if (this.CanShow === 1 || this.CanShowRegistryView === 1) {
      this.GetActorCertificationsInfoController();
    }

  }

  GetActorCertificationsInfoController() {
    this.StartRefreshing();
    this.hcpservice.GetActorCertificationsInfoController(this.CurrentActorCertificationRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //  console.log('this.ApiResData.Result-->' + this.ApiResData.Result.length);
          this.CurrentActorCertificationsInfoController = this.ApiResData.Result;
          this.initGridButton();

          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


      (error) => {

        if (error == "401 - Unauthorized") {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();



        }
        else {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();
        }
      }


      );

  }



  //

  // https://www.codeproject.com/Articles/1195569/Angular-Data-Grid-with-Sorting-Filtering-Export-to
  // dbops: DBOperation;
  //Grid Vars start
  isREADONLY: boolean = false;
  exportFileName: string = "IdentitiesList_";
  dbops: DBOperation;
  columns: any[] = [
    {
      display: 'Certificate Type',
      variable: 'CredentialType',
      filter: 'text',
    },
    {
      display: 'Certificate Number',
      variable: 'CredentialNumber',
      filter: 'text'
    },
    {
      display: 'Issuing Authority',
      variable: 'IssuingAuthorityLongValue',
      filter: 'text'
    }
    //,
    //{
    //  display: 'Date of Birth',
    //  variable: 'DOB',
    //  filter: 'date'
    //}
  ];
  sorting: any = {
    column: 'CredentialType',
    descending: false
  };
  hdrbtns: any[] = [];
  gridbtns: any[] = [];
  initGridButton() {

    this.hdrbtns = [
      {
        title: 'Add',
        keys: [''],
        action: DBOperation.create,
        ishide: false

      }];
    this.gridbtns = [
      //{
      //  title: 'Edit',
      //  keys: ['ActorCredentialCode'],
      //  action: DBOperation.update,
      //  ishide: false
      //},
      {
        title: 'XX',
        keys: ["ActorCredentialCode"],
        action: DBOperation.delete,
        ishide: false
      },
      {
        title: 'Detail',
        keys: ["ActorCredentialCode"],
        action: DBOperation.detail,
        ishide: false
      },
      {
        title: 'Doc',
        keys: ["ActorDocCode"],
        action: DBOperation.doc,
        ishide: false
      },

    ];

  }
  //Grid Vars end
  gridaction(gridaction: any): void {

    switch (gridaction.action) {
      case DBOperation.create:
        this.openNewContent();
        break;
      case DBOperation.update:
        // alertFunctions.AlertParam('update' + gridaction.values[0].value);
        //  this.editUser(gridaction.values[0].value);
        break;
      case DBOperation.delete:
        //alertFunctions.AlertParam('delete');
        // this.DeleteActorIdentities(gridaction.values[0].value);
        swal({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#0CC27E',
          cancelButtonColor: '#FF586B',
          confirmButtonText: 'Yes, delete it!',
          cancelButtonText: 'No, cancel!',
          confirmButtonClass: 'btn btn-success btn-raised mr-5',
          cancelButtonClass: 'btn btn-danger btn-raised',
          buttonsStyling: false
        }).then(() => {



          this.DeleteActorIdentities(gridaction.values[0].value);

        }, function (dismiss) {
          // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
          if (dismiss === 'cancel') {
            swal(
              'Cancelled',
              'Delete Operation Cancelled :)',
              'error'
            )
          }
        })

        break;
      case DBOperation.detail:
        this.OpenDetailContent(gridaction.values[0].value);
        break;
      case DBOperation.detail:
        // alertFunctions.AlertParam('Details');
        // alertFunctions.AlertParam(gridaction.values[0].value);
        this.OpenDetailContent(gridaction.values[0].value);
        break;
      case DBOperation.doc:
        this.openDocContent(gridaction.values[0].value);

        break;
    }
  }

  /////////////////////////////////////////////////////////////////////////
  //

  // Open content with dark section
  openNewContent() {
    const modalRef = this.modalService.open(NgbCertificationsinfoModal)
    modalRef.componentInstance.ActorCode = this.ActorCode;
    modalRef.result.then(x => { this.GetActorCertificationsInfoController() })

  }

  openDocContent(ActorDocCode: any) {
    if (ActorDocCode > 0) {
      let options: NgbModalOptions = {
        size: 'lg'
      };
      const modalRef = this.modalService.open(NgbActorDocsModal,options)//.result(result => { this.GetActorProfileController();});
      modalRef.componentInstance.ActorDocCode = ActorDocCode;

      modalRef.componentInstance.CanEdit = this.CanEdit;
      modalRef.componentInstance.CanShow = this.CanShow;
    }
    else {
      alertFunctions.AlertParam('No permission to Upload Doc For this Record...!');
    }
  }

  public SaveActorIdentities() {
    this.hcpservice.SaveActorCertifications(this.CurrentActorCertificationRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {

            alertFunctions.AlertParam('Saved Successfully.....!');


            this.stopRefreshing();
            this.GetActorCertificationsInfoController();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


      (error) => {

        if (error == "401 - Unauthorized") {
          alertFunctions.AlertParamEr(error);

          this.stopRefreshing();



        }
        else {
          alertFunctions.AlertParamEr(error);

          this.stopRefreshing();
        }
      }
      );

  }
  del_(ActorCredentialCode: any) {
    swal({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#0CC27E',
      cancelButtonColor: '#FF586B',
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, cancel!',
      confirmButtonClass: 'btn btn-success btn-raised mr-5',
      cancelButtonClass: 'btn btn-danger btn-raised',
      buttonsStyling: false
    }).then(() => {



      this.DeleteActorIdentities(ActorCredentialCode);

    }, function (dismiss) {
      // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
      if (dismiss === 'cancel') {
        swal(
          'Cancelled',
          'Delete Operation Cancelled :)',
          'error'
        )
      }
    })
  }
  DeleteActorIdentities(ActorCredentialCode: any) {


    console.log('..................');
    this.StartRefreshing();
    this.CurrentActorCertificationRequest.ConditionalOperator = 3;
    this.CurrentActorCertificationRequest.ActorCredentialCode = ActorCredentialCode;
    this.hcpservice.SaveActorCertifications(this.CurrentActorCertificationRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {

            alertFunctions.AlertParam('Saved Successfully.....!');


            this.stopRefreshing();
            this.GetActorCertificationsInfoController();
          }
          else {
            this.stopRefreshing();
            alertFunctions.AlertParam("Invalid Operation...!");
          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


      (error) => {

        if (error == "401 - Unauthorized") {
          alertFunctions.AlertParamEr(error);

          this.stopRefreshing();



        }
        else {
          alertFunctions.AlertParamEr(error);

          this.stopRefreshing();
        }
      }
      );

  }

  OpenDetailContent(ActorCredentialCode: any) {

    var CurrentActorCertificationsInfoControllerByCode = this.CurrentActorCertificationsInfoController.filter(x => x.ActorCredentialCode === parseInt(ActorCredentialCode));
    if (CurrentActorCertificationsInfoControllerByCode.length > 0) {
      const modalRef = this.modalService.open(NgbCertificationsinfoModal)
      modalRef.componentInstance.IsShowDetail = true;
      modalRef.componentInstance.ActorCode = this.ActorCode;
      modalRef.componentInstance.CurrentActorCertificationsInfoControllerByCode = CurrentActorCertificationsInfoControllerByCode[0];


    }
    else {
      alertFunctions.AlertParam('No Data Exits....!S');
    }

  }







  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }

}
